export enum IntegrationService {
  GONG = 'GONG',
  SALESLOFT = 'SALESLOFT',
}

export enum ExternalCallType {
  PHONE_CALL = 'PHONE_CALL',
  CONVERSATION = 'CONVERSATION',
}

export enum GongAuthMethod {
  OAUTH = 'OAUTH',
  CLIENT_CREDS = 'CLIENT_CREDS',
}

export enum SalesloftAuthMethod {
  OAUTH = 'OAUTH',
  API_KEY = 'API_KEY',
}

export enum IntegrationConnectionStatus {
  CONNECTED = 'Connected',
  FAILED = 'Connection failed',
  DISCONNECTED = 'Disconnected',
}

export enum IntegrationServiceAuthKey {
  GONG = 'gongAuth',
  SALESLOFT = 'salesloftAuth',
}

type IntegrationCallParty = {
  id: string;
  name: string;
  emailAddress?: string;
  speakerId?: string;
  userId?: string;
};

export type IntegrationCall = {
  id: string;
  title: string;
  duration: number;
  callDate: string;
  parties: IntegrationCallParty[];
};

export interface IntegrationUser {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber?: string;
}

export type GongAuth = {
  service: IntegrationService.GONG;
  expiresAt: Date | null;
  apiBaseUrl: string;
} & (
  | {
      authMethod: GongAuthMethod.OAUTH;
      accessKey: never;
      secretKeyLast4: never;
    }
  | {
      authMethod: GongAuthMethod.CLIENT_CREDS;
      accessKey: string;
      secretKeyLast4: string;
    }
);

export type SalesloftAuth = {
  service: IntegrationService.SALESLOFT;
  expiresAt: Date | null;
} & (
  | {
      authMethod: SalesloftAuthMethod.OAUTH;
      apiKeyLast4: never;
    }
  | {
      authMethod: SalesloftAuthMethod.API_KEY;
      apiKeyLast4: string;
    }
);
